import MindsetsJsSDK from "../../index";
import {LoadingAction} from "../layout/actions";
import {ErrorMessageAction} from "../components/CustomToast/actions";

export const LOADED_STREAMS = '[streams] Loaded Streams';
export const LOADED_STREAMS_CURRENT = '[streams] Loaded current';
export const LOADED_STREAMS_LIMIT = '[streams] Loaded limit';
export const LOADED_STREAMS_PAGES = '[streams] Loaded pages';
export const LOADED_STREAMS_TOTAL = '[streams] Loaded total';

export const LoadStreamsAction = options => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true, 'Loading Streams')))
        .then(() => MindsetsJsSDK().API.get(`streams`, options))
        .then(response => {
            dispatch(LoadedStreamsAction(response.items));
            dispatch(LoadedStreamsCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedStreamsLimitAction(response.limit));
            dispatch(LoadedStreamsPagesAction(response.pages));
            dispatch(LoadedStreamsTotalAction(response.total));
            dispatch(LoadingAction(false));

            return response.items;
        })
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const LoadedStreamsAction = payload => ({
    type: LOADED_STREAMS,
    payload
});
export const LoadedStreamsCurrentAction = payload => ({
    type: LOADED_STREAMS_CURRENT,
    payload
});
export const LoadedStreamsLimitAction = payload => ({
    type: LOADED_STREAMS_LIMIT,
    payload
});
export const LoadedStreamsPagesAction = payload => ({
    type: LOADED_STREAMS_PAGES,
    payload
});
export const LoadedStreamsTotalAction = payload => ({
    type: LOADED_STREAMS_TOTAL,
    payload
});

export const PauseStreamAction = stream_id => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.put(`streams/${stream_id}/status`, {status: 'paused'}))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const UnpauseStreamAction = stream_id => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.put(`streams/${stream_id}/status`, {status: 'started'}))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
export const DeleteStreamAction = stream_id => dispatch => {
    return Promise.resolve()
        .then(() => dispatch(LoadingAction(true)))
        .then(() => MindsetsJsSDK().API.delete(`streams/${stream_id}`))
        .then(() => dispatch(LoadingAction(false)))
        .catch(error => {
            dispatch(LoadingAction(false));
            dispatch(ErrorMessageAction(error));
            console.error(error);
        });
};
